import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import { DataService } from './services/data-service';
import { IUserStore } from './redux/user/types';
import { useDispatch } from 'react-redux';
import { LoginUser } from './redux/user/userReducer';
import { Protected } from './Protected';
// import LoginPage from "./auth-pages/Login";
import { getUserToken } from './helpers/user-token';
import { CircularProgress } from '@mui/material';
import Loader from './components/Loader';
import BaseLayout from './layouts/BaseLayout';
import LoginPage from './pages/auth-pages/Login';

interface IUserDetailsResponse {
  success: boolean;
  message: string;
  data: {
    email: string;
    role?: string;
    active: boolean;
    id: string;
    name: string;
  };
}

export const Portal: React.FC = () => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    DataService.get('api/User/details')
      .then(async (res) => {
        if (res.ok) {
          const result: IUserDetailsResponse = await res.json();
          if (result.success)
            var newStore: IUserStore = {
              token: getUserToken() || '',
              isAuthenticated: true,
              user: {
                email: result.data.email,
                id: result.data.id,
                name: result.data.name,
                role: result.data.role || '',
                active: result.data.active
              }
            };
          dispatch(LoginUser(newStore));
          setTimeout(() => {
            setLoaded(true);
          }, 500);
          setLoaded(true);
        } else {
          setLoaded(true);
        }
      })
      .catch(() => {
        setLoaded(true);
      });
  }, []);

  return loaded ? (
    <Routes>
      <Route path="login" element={<BaseLayout children={<LoginPage />} />} />
      <Route path="*" element={<Protected />} />
    </Routes>
  ) : (
    <Loader />
  );
};
